import { marked } from 'https://cdn.jsdelivr.net/npm/marked/lib/marked.esm.js';

export class HelpManager {
    constructor() {
        this.contents = {
            help: '',
            privacy: ''
        };
        this.currentDoc = 'help';
        this.docsPath = './docs/';
        
        // Initialize when DOM is ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.initialize());
        } else {
            this.initialize();
        }
    }

    async initialize() {
        const helpBtn = document.getElementById('helpBtn');
        const helpPanel = document.getElementById('helpPanel');
        const helpOverlay = document.getElementById('helpOverlay');
        const helpContent = helpPanel.querySelector('.help-content');

        // Load all content at startup
        await Promise.all([
            this.loadContent('help'),
            this.loadContent('privacy')
        ]);

        // Toggle help when clicking help button
        helpBtn.addEventListener('click', () => {
            helpPanel.classList.remove('hidden');
            helpOverlay.classList.remove('hidden');
            helpContent.innerHTML = marked.parse(this.contents[this.currentDoc]);
        });

        // Add tab buttons for switching between help and privacy
        const tabsHtml = `
            <div class="help-tabs">
                <button class="help-tab active" data-doc="help">Help & FAQ</button>
                <button class="help-tab" data-doc="privacy">Privacy Policy</button>
            </div>
        `;
        helpContent.insertAdjacentHTML('beforebegin', tabsHtml);

        // Handle tab switching
        const tabs = helpPanel.querySelectorAll('.help-tab');
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                // Update active tab
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');

                // Display cached content
                const doc = tab.dataset.doc;
                this.currentDoc = doc;
                helpContent.innerHTML = marked.parse(this.contents[doc]);
            });
        });
    }

    async loadContent(doc) {
        try {
            const response = await fetch(`${this.docsPath}${doc}.md`);
            if (!response.ok) throw new Error(`Failed to load ${doc} content`);
            this.contents[doc] = await response.text();
        } catch (error) {
            console.error('Error loading help content:', error);
            this.contents[doc] = '# Error\nFailed to load content. Please try again later.';
        }
    }
}
